/**
 * SWISA — variant sync
 *
 * Horizon does NOT re-render arbitrary theme blocks on variant change. The
 * variant picker fetches the whole product page, morphs only <variant-picker>,
 * then dispatches `variant:update` carrying the parsed Document.
 *
 * <swisa-sync> pulls its own freshly server-rendered markup out of that
 * Document and morphs itself, so any Liquid inside it (price, compare-at,
 * savings, bundle maths, availability) stays true to the selected variant
 * without duplicating pricing logic in JS.
 */
import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class SwisaSync extends Component {
  #scope = null;

  connectedCallback() {
    super.connectedCallback();
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#scope?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    const detail = event.detail || {};
    const data = detail.data || {};

    // Combined-listing guard, mirrors Horizon's own blocks.
    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (event.target?.dataset?.productId !== this.dataset.productId) {
      return;
    }

    // Quick-add requests return only the card section — our markup is absent.
    const next = data.html?.querySelector(`swisa-sync[data-block-id="${this.dataset.blockId}"]`);
    if (!next) return;

    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('swisa-sync')) {
  customElements.define('swisa-sync', SwisaSync);
}
